import { PAGE_PATH } from '@/lib/page-paths'
import { getCookie, setCookie } from '@/utils/cookies'
import { create } from 'zustand'

type OnOpenProps = {
  redirectUrl: string
}

type AuthModalStore = {
  isOpen: boolean
  onClose: () => void
  onOpen: (props: OnOpenProps) => void
  redirectUrl: string | null
}

export const useAuthModal = create<AuthModalStore>((set) => ({
  isOpen: false,
  onClose: () => set({ isOpen: false }),
  onOpen: (props: OnOpenProps) =>
    set({ isOpen: true, redirectUrl: setRedirectUrl(props.redirectUrl) }),
  redirectUrl: null, // Initialize as null to avoid SSR issues
}))

// Helper function to get redirect URL safely
export const getRedirectUrlFromStore = () => {
  const store = useAuthModal.getState()
  if (store.redirectUrl === null) {
    // Only call getRedirectUrl() when actually needed, not during store initialization
    const redirectUrl = getRedirectUrl()
    useAuthModal.setState({ redirectUrl })
    return redirectUrl
  }
  return store.redirectUrl
}

// we need to use cookie to store the redirect URL because the oauth/callback
// leaves and returns to the app, loosing any in-memory state
// we need to use a cookie over local/session storage because safari private browsing
// blocks local/session storage
function setRedirectUrl(redirectUrl: string) {
  setCookie('auth_redirect_url', redirectUrl, { maxAge: 3600 })
  return redirectUrl
}

function getRedirectUrl() {
  return getCookie('auth_redirect_url') || PAGE_PATH.HOME
}
